module.exports = __webpack_public_path__ + "img/shareImg.fc98b4f4.png";